module.exports = __webpack_public_path__ + "static/media/中邮证券app.7fdd9da.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/中邮证券app.mp4
// module id = gBQc
// module chunks = 3